import React from 'react'
import { Section, TaglineTitleContent } from 'newComponents'
import { ReactComponent as MetricStars } from '../../images/home/metric-stars.svg'
import { ReactComponent as LeftToggle } from '../../images/home/metrics-left-toggle.svg'
import { ReactComponent as RightStars } from '../../images/home/metrics-right-stars.svg'
import { ReactComponent as RightSphere } from '../../images/home/metrics-right-sphere.svg'
import './styles.scss'

const Metrics = (props) => {
  const { data } = props
  const { primary, items } = data
  const { title, tagline, content } = primary

  const metricTagline = tagline?.html
  const metricTitle = title?.html
  const metricContent = content?.html

  return (
    <Section className="metrics">
      <MetricStars className="metrics-stars" />
      <LeftToggle className="metrics-left-toggle" />
      <RightSphere className="metrics-right-sphere" />
      <RightStars className="metrics-right-stars" />
      <div className="metrics-top">
        <TaglineTitleContent tagline={metricTagline} title={metricTitle} content={metricContent} />
      </div>

      <div className="metrics-columns">
        {items.map((column) => {
          const { metric_property: metricProperty, metric_value: metricValue } = column

          const metricPropertyText = metricProperty?.text
          const metricPropertyHtml = metricProperty?.html
          const metricValueText = metricValue?.text

          return (
            <div className="metrics-column" key={metricPropertyText}>
              <span className="metrics-column-value">{metricValueText}</span>
              {metricPropertyHtml && (
                <div className="metrics-column-label" dangerouslySetInnerHTML={{ __html: metricPropertyHtml }} />
              )}
            </div>
          )
        })}
      </div>
    </Section>
  )
}

export default Metrics
